export default {
    private: {
        account: {
            subscriptions: {
                title: "Subscripciones"
            }
        }
    }
}